import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\lenovo\\Desktop\\interio_renov_premium\\interio_renov_premium\\src\\app\\service\\[id]\\ServiceDetailClient.tsx");
